const CertificationsPage = () =>
  import(/* webpackPrefetch: true */ './CertificationsPage.vue');
const SoftSkillsProPage = () =>
  import(/* webpackPrefetch: true */ './SoftSkillsProPage.vue');
const Disc10XPage = () =>
  import(/* webpackPrefetch: true */ './Disc10XPage.vue');
const OrientaCoachPage = () =>
  import(/* webpackPrefetch: true */ './OrientaCoachPage.vue');
const FormateurExceptionPage = () =>
  import(/* webpackPrefetch: true */ './FormateurExceptionPage.vue');

const routes = [
  {
    path: '/certifications',
    name: 'certifications',
    component: CertificationsPage,
    meta: {
      title: 'Nos Certifications - Formations Professionnelles',
      requiresAuth: false
    }
  },
  {
    path: '/certifications/soft-skills-pro',
    name: 'certifications.soft-skills-pro',
    component: SoftSkillsProPage,
    meta: {
      title: 'Soft Skills Pro - Certification en Compétences Douces',
      requiresAuth: false
    }
  },
  {
    path: '/certifications/disc-10x',
    name: 'certifications.disc-10x',
    component: Disc10XPage,
    meta: {
      title: '10× Productive - Certification en Productivité',
      requiresAuth: false
    }
  },
  {
    path: '/certifications/orienta-coach',
    name: 'certifications.orienta-coach',
    component: OrientaCoachPage,
    meta: {
      title: "Coach Orienta - Certification en Coaching d'Orientation",
      requiresAuth: false
    }
  },
  {
    path: '/certifications/formateur-exception',
    name: 'certifications.formateur-exception',
    component: FormateurExceptionPage,
    meta: {
      title: "Formateur d'Exception - Certification Pédagogique",
      requiresAuth: false
    }
  }
];

export default routes;
